import React from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@mui/material';
import { OneTimeLink } from '../../../services/portalAdmin.service';
import { useToast } from '../../../context/ToastContext';
import { formatDateTime } from '../../../utils/dateUtils';

// ---- P1-B customer portal ----
/** The link is returned exactly once by the server (only its hash is stored), so this is the only chance to copy it. */
const OneTimeLinkDialog: React.FC<{ link: OneTimeLink; onClose: () => void }> = ({ link, onClose }) => {
  const toast = useToast();
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(link.url);
      toast.showSuccess('Link copied');
    } catch {
      toast.showError('Could not copy; select the link and copy it by hand');
    }
  };
  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth data-help-page="sales.oneTimeLink.page">
      <DialogTitle>Link for {link.contact.name}</DialogTitle>
      <DialogContent data-help-section="sales.oneTimeLink.section.main">
        <Typography variant="body2" sx={{ mb: 2 }}>
          This link is shown once and works for one use. It expires {formatDateTime(link.expiresAt)}.
        </Typography>
        <TextField data-help="sales.oneTimeLink.url" fullWidth multiline minRows={2} value={link.url} InputProps={{ readOnly: true }} aria-label="One-time link"
          onFocus={e => e.target.select()} />
        {link.emailed
          ? <Alert severity="success" sx={{ mt: 2 }}>and e-mailed to {link.emailedTo ?? link.contact.email}</Alert>
          : <Alert severity="warning" sx={{ mt: 2 }}>Not e-mailed (portal e-mail is off). Copy the link and send it yourself.</Alert>}
      </DialogContent>
      <DialogActions>
        <Button data-help="sales.oneTimeLink.copy" variant="contained" onClick={copy}>Copy</Button>
        <Button data-help="sales.oneTimeLink.close" onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};

export default OneTimeLinkDialog;
// ---- end P1-B ----
